import React from 'react';
import { AccountPosition } from '../types';

interface PositionDetailsProps {
  position: AccountPosition;
  formatCurrency: (value: number) => string;
}

const PositionDetails: React.FC<PositionDetailsProps> = ({
  position,
  formatCurrency,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
      <div>
        <p className="text-sm text-gray-500">Position Type</p>
        <p className="font-medium">
          {position.actualPosition?.positionType ||
            position.targetHolding?.contractAssetType ||
            'N/A'}
        </p>
      </div>
      <div>
        <p className="text-sm text-gray-500">Trade Direction</p>
        <p className="font-medium">{position.tradeDirection}</p>
      </div>
      <div>
        <p className="text-sm text-gray-500">Allocated Capital</p>
        <p className="font-medium">
          {formatCurrency(position.allocatedCapital)}
        </p>
      </div>
    </div>
  );
};

export default PositionDetails;
